<!-- Popup listing the projects a storage image was added to. Each accessible project links
     to the image *in that project* by instance id (so it resolves even if the image was
     renamed there). Projects the user can't access are summarised as a muted note. -->
<template>
<b-modal :active="active" has-modal-card scroll="keep" @update:active="v => $emit('update:active', v)">
  <div class="modal-card ufpm-card" v-if="data">
    <header class="modal-card-head ufpm-head">
      <div>
        <div class="ufpm-title">{{ $t('projects-using-image') }}</div>
        <div class="ufpm-sub">{{ data.fileName }}</div>
      </div>
      <button class="delete" :aria-label="$t('button-close')" @click="$emit('update:active', false)"></button>
    </header>

    <section class="modal-card-body ufpm-body">
      <div v-if="data.accessible && data.accessible.length" class="ufpm-list">
        <router-link
          v-for="p in data.accessible"
          :key="p.projectId + '-' + p.instanceId"
          class="ufpm-row"
          :to="`/project/${p.projectId}/image/${p.instanceId}`"
          @click.native="$emit('update:active', false)"
        >
          <span class="ufpm-pico"><i class="fas fa-layer-group"></i></span>
          <span class="ufpm-pinfo">
            <span class="ufpm-pname">{{ p.projectName }}</span>
            <span class="ufpm-pfile">{{ p.instanceFilename }}</span>
          </span>
          <i class="fas fa-arrow-right ufpm-go"></i>
        </router-link>
      </div>
      <div v-else class="ufpm-empty">
        <span class="ufpm-empty-ico"><i class="far fa-folder-open"></i></span>
        {{ $t('image-not-in-any-project') }}
      </div>

      <div v-if="data.inaccessibleCount > 0" class="ufpm-note">
        <i class="fas fa-lock"></i>
        {{ $t('n-projects-no-access', {count: data.inaccessibleCount}) }}
      </div>
    </section>
  </div>
</b-modal>
</template>

<script>
export default {
  name: 'uploaded-file-projects-modal',
  props: {
    active: {type: Boolean, default: false},
    data: {type: Object, default: null}
  }
};
</script>

<style scoped>
.ufpm-card { width: 460px; max-width: 92vw; border-radius: 16px; overflow: hidden; }
.ufpm-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 18px 22px;
  border-bottom: 1px solid #eef1f6;
  background: #fff;
}
.ufpm-title { font-size: 16px; font-weight: 800; color: #0f172a; }
.ufpm-sub { font-size: 12.5px; color: #94a3b8; margin-top: 2px; word-break: break-all; }
.ufpm-body { padding: 14px 16px 18px; background: #fff; max-height: 60vh; overflow-y: auto; }

.ufpm-list { display: flex; flex-direction: column; gap: 8px; }
.ufpm-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 13px;
  border: 1px solid #eef1f6;
  border-radius: 11px;
  background: #fff;
  text-decoration: none;
  transition: 0.14s;
}
.ufpm-row:hover { border-color: #bfd4fb; background: #f4f8ff; }
.ufpm-pico {
  width: 36px; height: 36px; flex: 0 0 36px; border-radius: 10px;
  background: linear-gradient(135deg, #eaf1fe, #dce7fb); color: #1f6fe5;
  display: flex; align-items: center; justify-content: center;
}
.ufpm-pinfo { min-width: 0; flex: 1; display: flex; flex-direction: column; }
.ufpm-pname { font-size: 14px; font-weight: 700; color: #1e293b; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ufpm-pfile { font-size: 12px; color: #94a3b8; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.ufpm-go { color: #94a3b8; font-size: 13px; flex: 0 0 auto; }
.ufpm-row:hover .ufpm-go { color: #1f6fe5; }

.ufpm-empty {
  display: flex; flex-direction: column; align-items: center; gap: 10px;
  padding: 32px 16px; text-align: center; color: #94a3b8; font-size: 14px;
}
.ufpm-empty-ico {
  width: 48px; height: 48px; border-radius: 13px; background: #f4f7fb;
  display: flex; align-items: center; justify-content: center; font-size: 20px;
}
.ufpm-note {
  margin-top: 14px;
  display: flex; align-items: center; gap: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: #f8fafc;
  color: #64748b;
  font-size: 12.5px;
}
.ufpm-note .fas { color: #94a3b8; }
</style>
